import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';

import { Select, type SelectProps } from '../../../Toolkit/Inputs/Select';
import { usePanelContentsSubscribe } from '../../components/Panels/shared/CollapsiblePanel/CollapsiblePanel.hook';
import { preventSubmit } from './preventSubmit';

type FinanceSelectProps = Omit<
  SelectProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceSelect = forwardRef<HTMLSelectElement, FinanceSelectProps>(
  (props, ref) => {
    const { invalid, value, isOptional = false, ...rest } = props;
    usePanelContentsSubscribe({
      name: props.name,
      value,
      invalid,
      isOptional,
    });
    return (
      <Select
        {...rest}
        hasError={invalid}
        errorMessage={props.error?.message}
        ref={ref}
        value={value}
        onKeyDown={preventSubmit}
      />
    );
  },
);

FinanceSelect.displayName = 'FinanceSelect';
